import { camelCase, isObject } from 'lodash-es';

export const normalizeObjectKeys = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (isObject(value)) {
        return [camelCase(key), normalizeObjectKeys(value)];
      }

      return [camelCase(key), value];
    }),
  );
};

export const extractPropsFromPromotion = (originalProps) => {
  const { userOrganizationId, show, feature, promotionType, appendAction, appendSelector, ...bannerProps } =
    normalizeObjectKeys(originalProps);
  const appendElement = appendSelector ? document.querySelector(appendSelector) : null;

  const finalProps = {
    show,
    feature,
    promotionType,
    userOrganizationId,
    append: {
      action: appendAction,
      element: appendElement,
    },
    bannerProps,
  };

  return finalProps;
};
